import { useEffect, useMemo, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  ControlCenterSelectors,
  UserContextSelectors
} from "../../../redux/selectors/index.js";
import { PageContextUtils } from "../../../utils/index.js";
import { AppFeatures } from "../../../constants/featureFlags.js";
import { RegulationTypeIds } from "../../../constants/index.js";
import { Brand } from "../../../configurations/index.js";
import { BrandUtils } from "../../../utils/brandUtils.js";
import { ControlCenterActionCreators } from "../../../redux/action-creators/index.js";
import { useFeature } from "../../../hooks/index.js";

const ComBrands = [Brand.Sport_Com, Brand.Sport_Spoker, Brand.Sport_Scasino];

export const useControlCenterState = () => {
  const enabled = useSelector(ControlCenterSelectors.enabled);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const brandId = useSelector(UserContextSelectors.brandId);
  const isComBrand = useMemo(
    () => ComBrands.some(brand => brand === brandId),
    [brandId]
  );
  const dispatch = useDispatch();

  const setControlCenterEnabled = useCallback(
    isEnabled => dispatch(ControlCenterActionCreators.setEnabled(isEnabled)),
    [dispatch]
  );

  const isControlCenterActive = useFeature(
    AppFeatures.CONTROL_CENTER,
    AppFeatures.SAFEZONE_GENERIC
  );

  useEffect(() => {
    if (isAuthenticated) {
      const getControlCenterEnabled = () => {
        let isActiveForCurrentRegulationType = true;

        const { regulationTypeId } = PageContextUtils.getRegulationData();

        if (BrandUtils.isPokerClient()) {
          isActiveForCurrentRegulationType =
            regulationTypeId === RegulationTypeIds.UK;
        }

        setControlCenterEnabled(
          isControlCenterActive && isActiveForCurrentRegulationType
        );
      };

      getControlCenterEnabled();
    }
  }, [
    isAuthenticated,
    isComBrand,
    isControlCenterActive,
    setControlCenterEnabled
  ]);

  return enabled;
};
